import { type ExamEventOverviewReportFilterFormOutput } from './schema';

export function mapFormValuesToSearchParams(formValues: ExamEventOverviewReportFilterFormOutput) {
  const { examCenter, province, startDate, endDate, registrationType, examType } = formValues;
  return {
    examCenter: examCenter.map((item) => item.value),
    province: province.map((item) => item.value),
    startDate: startDate,
    endDate: endDate,
    registrationType: registrationType.map((item) => item.value),
    examType: examType.map((item) => item.value),
  };
}
